import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.FirstTimeSetupPages.MobileSuccessInfo', {
    successTextIPhone:
        'Approve requests on the go by clicking {br}the respective button in the "Approval required" email.{br}{br}Or download the iPhone app and get full {br}access to all requests.',
    successTextAndroid:
        'Approve requests on the go by clicking {br}the respective button in the "Approval required" email.{br}{br}Or download the Android app and get full {br}access to all requests.',
});
